<template>
    <div class="wrapper">
      <div class="row">
      <div class="col-md-3">
        <MultiSelect v-model="selectedOptions" :options="item.values" optionLabel="name" :filter="true" placeholder="Välj plats.." style="width:100%" @change="addItem($event.value)" :dataKey="item.values.id" >
          <template #value="slotProps">
            <div v-if="slotProps.value.length === 1">
                1 plats vald
            </div>
            <div v-if="slotProps.value.length > 1">
              {{slotProps.value.length}} platser valda
            </div>
            <div v-if="!slotProps.value || slotProps.value.length === 0">
              <span>Välj plats..</span>
             </div>
          </template>
          <template #option="slotProps">
            <span>{{slotProps.option.name}} {{slotProps.option.city}}</span>
            </template>
        </MultiSelect>
      </div>
      <div class="col-md-9">
        <DataTable :value="selectedItems" :reorderableColumns="false" @row-reorder="onRowReorder">
          <Column :rowReorder="true" headerStyle="width: 3rem" :reorderableColumn="false" />
          <Column header="Namn">
              <template #body="slotProps" >
                  {{slotProps.data.name}} {{slotProps.data.city}}
              </template>
          </Column>
          <Column header="Fraktion">
              <template #body="slotProps" >
               <Dropdown style="width:100%" v-model="slotProps.data.selectedFraction" :options="slotProps.data.fractions" optionLabel="name" placeholder="Välj fraktion.." @change="setForbehandlare($event.value.id, slotProps.data)" />
            </template>
          </Column>
          <Column header="Förbehandlare">
              <template #body="slotProps" >
               <Dropdown style="width:100%" v-model="slotProps.data.selectedForbehandlare" :options="slotProps.data.forbehandlare" optionLabel="name" placeholder="Välj förbehandlare.." />
            </template>
          </Column>
          <Column header="Antal">
            <template #body="slotProps" >
              <InputText type="text" v-model="slotProps.data.containerAmount" />
            </template>
          </Column>
          <Column header="Containers">
            <template #body="slotProps" >
              <MultiSelect style="width:100%" v-model="slotProps.data.selectedContainers" :options="slotProps.data.containers" optionLabel="containerName" placeholder="Välj containers.." />
            </template>
          </Column>
          <Column header="Kommentar">
            <template #body="slotProps" >
              <InputText type="text" v-model="slotProps.data.comment" />
            </template>
          </Column>
          <Column header="Avisera" headerStyle="width: 6rem">
            <template #body="slotProps">
              <Checkbox id="notice" v-model="slotProps.data.notice" :binary="true" />
            </template>
          </Column>
          <Column header="" headerStyle="width: 3rem">
            <template #body="slotProps">
              <Button icon="pi pi-ban" @click.prevent="removeItem(slotProps.data)" />
            </template>
          </Column>
        </DataTable>
      </div>
      </div>
    </div>
</template>
<script>
import { abstractField } from 'vue-form-generator'
import MultiSelect from 'primevue/multiselect'
import InputText from 'primevue/inputtext'
import DataTable from 'primevue/datatable'
import Dropdown from 'primevue/dropdown'
import Checkbox from 'primevue/checkbox'
import Column from 'primevue/column'
import Button from 'primevue/button'
import { isNil } from 'lodash'
export default {
  beforeMount () {
    if (isNil(this.value)) {
      this.value = []
    }
  },
  data () {
    return {
      selectedOptions: null
    }
  },
  components: {
    MultiSelect,
    InputText,
    Dropdown,
    Checkbox,
    DataTable,
    Column,
    Button
  },
  mixins: [abstractField],
  async created () {
    if (this.value) {
      this.value.map((el) => ({id: el.id, name: el.name, city: el.city, type: el.type, forbehandlare: el.forbehandlare, selectedForbehandlare: el.selectedForbehandlare, selectedFraction: el.selectedFraction, fractions: el.fractions, standardPlaces: el.standardPlaces, containerAmount: el.containerAmount, containers: el.containers, selectedContainers: el.selectedContainers, notice: el.notice, comment: el.comment}))
    } else {
      this.value = []
    }
    this.selectedOptions = this.value
  },
  computed: {
    selectedItems: {
      get: function () {
        return this.selectedOptions.filter((el) => this.value.find(x => x.id === el.id))
      },
      set: function (newValue) {
        return newValue
      }
    },
    item: {
      get: function () {
        return this.schema
      },
      set: function (newValue) {
        return newValue
      }
    }
  },
  methods: {
    onRowReorder (event) {
      this.selectedOptions = event.value
      this.value = event.value
    },
    addItem (value) {
      this.value = value.map((el) => {
        return typeof el === 'object' ? el : {id: el}
      })
    },
    removeItem (item) {
      this.value.forEach((element, index) => {
        if (element.id === item.id) {
          this.value.splice(index, 1)
        }
      })
    },
    setForbehandlare (value, object) {
      let selectedForbehandlare = {}
      object.forbehandlare.forEach((forbehandlare) => {
        if (forbehandlare.fractions) {
          forbehandlare.fractions.forEach((fraction) => {
            if (fraction === value) {
              selectedForbehandlare = forbehandlare
            }
          })
        }
      })
      if (selectedForbehandlare !== {}) {
        object.selectedForbehandlare = selectedForbehandlare
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/vfg-custom-fields/fieldAddAVC.vue